__turbopack_context__.v({
  "productsAndRegionsContainer": "userPreferences-module-scss-module__xwHFza__productsAndRegionsContainer",
  "productsAndRegionsHint": "userPreferences-module-scss-module__xwHFza__productsAndRegionsHint",
  "productsAndRegionsTitle": "userPreferences-module-scss-module__xwHFza__productsAndRegionsTitle",
  "section": "userPreferences-module-scss-module__xwHFza__section",
  "select": "userPreferences-module-scss-module__xwHFza__select",
});
